// StickerPicker.jsx
import React, { useState, useEffect, useRef } from 'react';
import FileAttachment from './media/FileAttachment';
import './StickerPicker.css'
import api from '../Api';

const StickerPicker = ({ onSelect, onClose }) => {
    const [packs, setPacks] = useState([]);
    const [selectedPack, setSelectedPack] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const pickerRef = useRef(null);

    useEffect(() => {
        // Закрываем при клике вне
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    useEffect(() => {
          console.log('🔄 Loading stickers...');
        loadPublicStickers();
        return () => {
        console.log('🧹 StickerPicker unmounted');
    };
    }, []);
    const loadPublicStickers = async () => {
        try {
            setLoading(true);
            setError(null);   
            const response=await api.get('/stickers/public')             
           if (Array.isArray(response.data)) {            
            setPacks(response.data);
            if (response.data.length > 0) {
                setSelectedPack(response.data[0]);
            }
        } else {
            throw new Error('Invalid response format');
        }
    } catch (err) {
        console.error('Error loading stickers:', err);
        setError('Не удалось загрузить стикеры');
    } finally {
        setLoading(false);
    }
    };
    // Обработчик клика по стикеру
    const handleStickerClick = (sticker) => {
        console.log('🎯 Sticker selected:', sticker);
        
        // Вызываем onSelect с данными стикера
        onSelect({
            id: sticker.id,
            url: sticker.file_url,
            emoji: sticker.emoji || '📷',
            file_type: sticker.file_type || 'static'
        });        
        // Закрываем панель
        onClose();
    };

    if (loading) {
        return (
            <div className="sticker-picker" ref={pickerRef}>
                <div className="sticker-loading">Загрузка...</div>
            </div>
        );
    }
    if (error) {
        return (
            <div className="sticker-picker" ref={pickerRef}>
                <div className="sticker-error">
                    <i className="bi-exclamation-circle"></i>
                    <p>{error}</p>
                    <button onClick={loadPublicStickers} className="sticker-retry-btn">
                        <i className="bi-arrow-clockwise"></i> Повторить
                    </button>
                </div>
            </div>
        );
    }

    if (packs.length === 0) {
        return (
            <div className="sticker-picker" ref={pickerRef}>
                <div className="sticker-empty">
                    <p>Стикеров пока нет</p>
                    <small>Стикеры появятся здесь</small>
                </div>
            </div>
        );
    }

    return (
        <div className="sticker-picker" ref={pickerRef}>
            <div className="sticker-picker-header">
                <span className="sticker-title">Стикеры</span>
                <button className="sticker-close" onClick={onClose}>
                    <i className="bi-x-lg"></i>
                </button>
            </div>

            {/* Вкладки наборов */}
            <div className="sticker-tabs">
                {packs.map(pack => (
                    <button
                        key={pack.id}
                        className={`sticker-tab ${selectedPack?.id === pack.id ? 'active' : ''}`}
                        onClick={() => setSelectedPack(pack)}
                    >
                        {pack.title}
                    </button>
                ))}
            </div>

            {/* Сетка стикеров */}
            <div className="sticker-grid">
                {selectedPack?.stickers?.map(sticker => (
                    <div 
                        key={sticker.id}
                        className="sticker-item-wrapper"
                        onClick={() => handleStickerClick(sticker)}
                        title={sticker.emoji || 'Стикер'}
                    >                       
                       <FileAttachment
                        mediaUrl={sticker.file_url}
                        fileName={sticker.fileName}
                        className='sticker-item'
                        />          
                     {/*  <img 
                            src={sticker.file_url}
                            alt={sticker.emoji || 'Стикер'}
                            className="sticker-item"
                            loading="lazy"
                            decoding="async"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22/%3E';
                            }}
                        /> */}
                    </div>
                ))}
                {selectedPack?.stickers?.length === 0 && (
                    <div className="sticker-empty-pack">
                       <i className="bi-emoji-neutral"></i>
                        <span>Нет стикеров в этом наборе</span>
                        </div>
                )}
            </div>
             {/* Информация о наборе */}
            <div className="sticker-pack-info">
                <span className="sticker-count">
                    <i className="bi-images"></i> {selectedPack?.stickers?.length || 0} стикеров
                </span>
                {selectedPack?.is_public && (
                    <span className="public-label">
                        <i className="bi-globe2"></i> Публичный
                    </span>
                )}
            </div>
        </div>
    );
};

export default StickerPicker;